/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import { Link } from 'react-router-dom';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import SelectorTools from 'app/utility/SelectorTools.js';

class SocialButton extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hover: false
		};

		this.configClick = this.configClick.bind(this);
		this.twitterNoticeRollover = this.twitterNoticeRollover.bind(this);

	}

	configClick() {
		this.props.configClickHandler(e, this.props.output);
	}

	twitterNoticeRollover(e) {
		this.setState({
			hover: (hover) ? false : true
		});
	}

	render() {
		let ServiceIcon = null,
			avatarUrl = null,
			serviceId = 0,
			config = null,
			label = '',
			inactive = false,
			mainClass = '',
			labelClass = 'social-label',
			isTwitter = false,
			social = null,
			subType = null,
			subTypeLabel = '',
			subTypeId = null,
			constants = this.props.app.config.constants,
			serviceIcon = null,
			connectAction = null;

		if (this.props.output.social) {
			social = this.props.output.social;
		} else if (this.props.social) {
			social = this.props.social;
		} else {
			// houston we have a problem
			return null;
		}

		// check for a subtype (coming soon for facebook)
		if (social.subType) {
			subTypeId = parseInt(social.subType, 10);
		}

		if (this.props.output.activeFlag !== undefined) {
			if (parseInt(this.props.output.activeFlag, 10) === 0 || parseInt(social.activeFlag, 10) === 0 || this.props.inactive === true) {
				inactive = true;
			}
		} else if (parseInt(social.activeFlag, 10) === 0 || this.props.inactive === true) {
			inactive = true;
		}

		label = social.name;

		mainClass = classnames(
			'social-button',
			ConstantMixin.getIconIndexByCode(social.psID),
			{
				'inactive': inactive,
				'connect': this.props.connect,
				'unselected': this.props.unselected && this.props.context !== 'queue',
				'selected': this.props.selected,
				'error': (parseInt(social.sysActionFlag, 10) === 1 && parseInt(social.activeFlag, 10) === 1) ? true : false,
				'static': this.props.frozen,
				'queue': this.props.context === 'queue',
				'onboarding': this.props.onboarding
			}
		);

		if (this.props.config) {
			config = <div className="social-config" onClick={this.configClick} role='button' aria-label="configure social"><i className="fa fa-gear"></i></div>;
		}

		if (!this.props.connect) {
			if (parseInt(social.psID, 10) === constants.POST_SVC_TWITTER) {
				label = ['@', label].join('');
			}
		} else {
			label = "Connect New";
		}

		if (subTypeId !== null && parseInt(subTypeId, 10) > 0) {
			labelClass += " with-subtype";
			switch (subTypeId) {
				case constants.LI_PERSON:
					subTypeLabel = "Person";
					break;

				case constants.LI_COMPANY:
					subTypeLabel = 'Company'
					break;

				case constants.FB_PROFILE:
					subTypeLabel = "Profile";
					break;

				case constants.FB_GROUP:
					subTypeLabel = "Group";
					break;

				case constants.FB_PAGE:
					subTypeLabel = "Page";
					break;

				default:
					subTypeLabel = 'Subtype'
			}
			subType = (
				<div className="social-subtype">
					{subTypeLabel}
				</div>
			);
		}

		if (this.props.connectAction) {
			connectAction = this.props.connectAction;
		}

		if (this.props.context === 'queue') {
			if (!labelClass.match("with-subtype")) {
				labelClass += " with-subtype queue";
			} else {
				labelClass += " queue";
			}

			subType = (
				<div className="social-subtype queue-fill">
					{this.props.customSubLabel}
				</div>
			);
		}

		return (
			<div className={mainClass}
					onClick={connectAction}
					alt={label}
					title={label}
					data-direct={this.props.direct}
					data-serviceid={this.props.serviceId}
					role="button"
					aria-label="connect social">
				{config}
				<SocialAvatar
					social={social}
					retweet={this.props.retweet}
					connect={this.props.connect}
					type='button'
					large={true}
					context={this.props.context}
					wrapperClass={(this.props.onboarding) ? 'onboarding' : ''}
					dashed={inactive}/>
				<div className={labelClass}>
					{label}
				</div>
				{subType}
			</div>
		);
	}
};

SocialButton.propTypes = {
	social: PropTypes.object,
	output: PropTypes.object,
	connect: PropTypes.bool,
	connectAction: PropTypes.func,
	config: PropTypes.bool,
	configClickHandler: PropTypes.func,
	unselected: PropTypes.bool,
	inactive: PropTypes.bool,
	frozen: PropTypes.bool,
	direct: PropTypes.bool,
	serviceId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	context: PropTypes.string,
	customSubLabel: PropTypes.string
};

SocialButton.defaultProps = {
	social: {},
	output: {},
	connect: false,
	connectAction: null,
	config: false,
	unselected: false,
	inactive: false,
	frozen: false,
	direct: false,
	serviceId: 0,
	context: '',
	customSubLabel: '',
	onboarding: false
};

export default SocialButton;
